<template>
    <div class="login-container other" ref="login" @keyup.enter.native="handleLogin">
        <loginHeader></loginHeader>
        <el-form :model="ruleForm" :inline-message="true" :rules="rules" ref="ruleForm" label-width="100px" class="other-form">
            <el-form-item label="登录名：" prop="name">
                <div class="forget-line">
                    <div class="input">
                        <el-input v-model="ruleForm.name"></el-input>
                    </div>
                    <div class="ml10 flex-one red">忘记登录名，请点击找回登录名</div>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="forget-line">
                    <i class="el-icon-info blue icon"></i>
                    <div class="tips">用户，登录名格式：XM+8位ID+@bjx.com 如：ID：12345678，<br />登录名：12345678@bjx.com</div>
                </div>
            </el-form-item>
            <el-form-item label="验证：" prop="name">
                <div class="forget-line">
                    <div class="input c6 fs14">
                        请拖动滑条完成验证码发送
                    </div>
                </div>
                <div class="forget-line">
                    <div class="input mt10">
                        <JcRange status="loginForm.status" :successFun="onMpanelSuccess" :errorFun="onMpanelError"></JcRange>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="邮箱/手机：" prop="name">
                <div class="forget-line">
                    <div class="input">
                        <el-input v-model="ruleForm.name"></el-input>
                    </div>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="forget-line">
                    <div class="input">
                        <el-button type="primary" class="w100" @click="submitForm('ruleForm')">确认</el-button>
                    </div>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import loginHeader from './components/loginheader'
import { mapGetters } from "vuex";
import { dateFormat } from "@/util/date";
import { validatenull } from "@/util/validate";
import { getQueryString, getTopUrl } from "@/util/util";
import JcRange from "@/components/JcRange/index.vue";

export default {
    name: "login",
    components: {
        loginHeader,
        JcRange
    },
    data() {
        return {
            time: "",
            activeName: "user",
            socialForm: {
                tenantId: "000000",
                source: "",
                code: "",
                state: "",
            },
            ruleForm: {
                name: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                    { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ]
            }
        };
    },
    watch: {
        $route() {
            this.handleLogin();
        }
    },
    created() {
        this.handleLogin();
        this.getTime();
    },
    mounted() {},
    computed: {
        ...mapGetters(["website", "tagWel"])
    },
    props: [],
    methods: {
        getTime() {
            setInterval(() => {
                this.time = dateFormat(new Date());
            }, 1000);
        },
        handleLogin() {
            const topUrl = getTopUrl();
            const redirectUrl = "/oauth/redirect/";
            this.socialForm.source = getQueryString("source");
            this.socialForm.code = getQueryString("code");
            this.socialForm.state = getQueryString("state");
            if (validatenull(this.socialForm.source) && topUrl.includes(redirectUrl)) {
                let source = topUrl.split("?")[0];
                source = source.split(redirectUrl)[1];
                this.socialForm.source = source;
            }
            if (!validatenull(this.socialForm.source) && !validatenull(this.socialForm.code) && !validatenull(this.socialForm.state)) {
                const loading = this.$loading({
                    lock: true,
                    text: '第三方系统登录中,请稍后。。。',
                    spinner: "el-icon-loading"
                });
                this.$store.dispatch("LoginBySocial", this.socialForm).then(() => {
                    window.location.href = topUrl.split(redirectUrl)[0];
                    this.$router.push({ path: this.tagWel.value });
                    loading.close();
                }).catch(() => {
                    loading.close();
                });
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
};

</script>
<style lang="scss">
@import "@/styles/login.scss";

</style>
